import React from 'react'

import { useGroup, useUser } from '../../state/entities'
import GroupSlug from './GroupSlug/GroupSlug'
import UserSlug from './UserSlug/UserSlug'

export default React.memo(function AssignedBySlug({
  assignment,
}: {
  assignment?: { assignedByUserUuid?: string | null | undefined; assignedByGroupUuid?: string | null | undefined }
}) {
  const { user } = useUser(assignment?.assignedByUserUuid)
  const { group } = useGroup(assignment?.assignedByGroupUuid)

  if (assignment?.assignedByUserUuid) {
    return <UserSlug user={user} />
  }
  if (assignment?.assignedByGroupUuid) {
    return <GroupSlug group={group} />
  }
  return null
})
